import CampaignsAdminPage from './CampaignsAdminPage';
export default CampaignsAdminPage;
